import { defineMessages } from 'react-intl';

export default defineMessages({
  failed: {
    id: 'failed',
    defaultMessage: 'Failed'
  }
});
